import React, { useContext, useEffect } from "react";
import { Text, Space } from "react_reusable_components";
import { useIntl } from "react-intl";
import { TwoColumn } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import NotificationService from "../../services/notification-service";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import { NotificationsContext } from "../../globalContext/notifications/notificationsProvider";
import moment from "moment";
import { getDayWiseNotification } from "../../UtilityFunctions/utils";
import { setAllRead } from "../../globalContext/notifications/notificationsActions";

const notificationDetailStyle = {
  notifcationContainerStyle: {
    backgroundColor: variables.bodyBg,
    alignItems: variables.alignCenter,
    display: variables.dFlex,
    border: `1px solid ${variables.grey5}`,
    justifyContent: variables.spaceBetween,
    padding: `${variables.paddingSmaller} ${variables.paddingSmall}`,
  },
  notificationRowLeftColumnStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    gap: variables.gapXS,
  },
  notificationMessageStyle: {
    lineHeight: variables.lineHeightNormal,
    flex: 1,
    fontSize: variables.fontSizeSmall,
  },
  notificationTimeStyle: {
    textAlign: "end",
    fontSize: variables.fontSizeSmall,
    color: variables.grey2,
    width: "4.063rem",
    lineHeight: variables.lineHeightMedium,
  },
  notificationDateWrapperStyle: {
    padding: `${variables.paddingSmaller} ${variables.paddingSmall}`,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    backgroundColor: variables.azuerishWhite,
    color: variables.textDefault,
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    marginBottom: variables.marginSmallest,
    width: "7.2rem",
  },
};

export default function SeeAllNotificationsContainer() {
  const [, loaderDispatch] = useContext(GlobalLoaderContext);
  const intl = useIntl();
  const [notificationState, notificationDispatch] =
    useContext(NotificationsContext);

  useEffect(() => {
    NotificationService.getAllNotifications({
      dispatch: notificationDispatch,
      intl,
      loaderDispatch,
    });
    
    NotificationService.markNotificationRead({ loaderDispatch, intl })
      .then(() => {
        notificationDispatch(setAllRead(true));
      })
      .catch(() => {}); //NOSONAR;
  }, [intl, loaderDispatch, notificationDispatch]);

  const notificationData = getDayWiseNotification(
    notificationState?.notificationsList
  );

  return (
    <Space
      size={0}
      direction="vertical"
      style={{
        gap: variables.gapMediumSmall,
      }}
    >
      {notificationData?.map((notifications) => (
        <Space
          key={notifications.id}
          size={0}
          direction="vertical"
          style={{
            display: variables.dFlex,
            flexDirection: "column",
            gap: variables.gapXS1,
          }}
        >
          <Text style={notificationDetailStyle.notificationDateWrapperStyle}>
            {notifications?.day}
          </Text>

          {notifications?.notifications?.map((singleNotification) => {
            return (
              <TwoColumn
                key={singleNotification.id}
                style={{
                  ...notificationDetailStyle.notifcationContainerStyle,
                }}
                leftSectionStyle={{ flex: 1 }}
                leftSection={
                  <TwoColumn
                    style={
                      notificationDetailStyle.notificationRowLeftColumnStyle
                    }
                    leftSection={
                      <img src={"/icons/polygon_red.svg"} alt={"Status"} />
                    }
                    rightSectionStyle={{ flex: 1 }}
                    rightSection={
                      <Text
                        style={notificationDetailStyle.notificationMessageStyle}
                        type="secondary"
                      >
                        {singleNotification?.message}
                      </Text>
                    }
                  />
                }
                rightSection={
                  <Text style={notificationDetailStyle.notificationTimeStyle}>
                    {moment(singleNotification?.created_at).format("hh:mm A")}
                  </Text>
                }
              />
            );
          })}
        </Space>
      ))}
    </Space>
  );
}
